export default "__VITE_ASSET__a8baffed__"